/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host {
  box-sizing: border-box;
  display: flex;
  font-size: 1rem;
}

.navigation {
  height: calc(39rem /14);
  width: 100%;
  background-color: #EEEFF0;
  background-color: var(--davinci-color-background-3, #EEEFF0);
}
.navigation.minimal .items {
  flex-direction: row-reverse;
}

.items {
  align-items: center;
  display: flex;
  flex-direction: row;
  height: calc(36rem /14);
  width: 100%;
}

.bottom-line {
  height: calc(3rem /14);
  width: 100%;
  background-color: var(--davinci-color-outline-disabled, );
}`;
export { style };
